import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import { useLanguage, Language } from '../../contexts/LanguageContext';

export default function LanguageSwitcher() {
  const { language, setLanguage, t } = useLanguage();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (newLanguage: Language) => {
    setLanguage(newLanguage);
    handleClose();

    // Navigate to root and trigger landing page
    window.location.reload();
  };

  return (
    <React.Fragment>
      <Tooltip title={t('language.changeLanguage')} enterDelay={1000}>
        <div>
          <IconButton
            size="small"
            aria-label={t('language.changeLanguage')}
            aria-controls={open ? 'language-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
          >
            <Box
              sx={{
                fontSize: '1.2rem',
                fontWeight: 'bold',
                width: 24,
                height: 24,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img
                src={language === 'ar' ? 'https://flagcdn.com/w20/ae.png' : 'https://flagcdn.com/w20/us.png'}
                alt={language === 'ar' ? 'UAE Flag' : 'US Flag'}
                style={{ width: 20, height: 15 }}
              />
            </Box>
          </IconButton>
        </div>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="language-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            variant: 'outlined',
            elevation: 0,
            sx: {
              my: '4px',
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem
          selected={language === 'en'}
          onClick={() => handleLanguageChange('en')}
        >
          <img
            src="https://flagcdn.com/w20/us.png"
            alt="US Flag"
            style={{ width: 20, height: 15 }}
          />
        </MenuItem>
        <MenuItem
          selected={language === 'ar'}
          onClick={() => handleLanguageChange('ar')}
        >
          <img
            src="https://flagcdn.com/w20/ae.png"
            alt="UAE Flag"
            style={{ width: 20, height: 15 }}
          />
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}

